import { BASE_URL } from "./enum.js";

export const fetchVerifyPassKey = async (eventId, passKey) => {
  try {
    const response = await fetch(`${BASE_URL}/api/events/${eventId}/verify-pass`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pass_key: passKey }),
    });

    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    }

    const result = await response.json();
    return result; // { success: true/false, message: "..." }
  } catch (error) {
    console.error("Error verifying pass key:", error);
    return { success: false, message: "Network or server error" };
  }
}
